import * as React from "react";
import PropTypes from "prop-types";
import { getTitleBase } from "./utilities";

function Seo(props) {
  const { title, description, noIndex } = props;

  return (
    <>
      <title>
        {title} | {getTitleBase()}
      </title>
      <meta name="description" content={description} />
      {noIndex ? <meta name="robots" content="noindex" /> : null}
    </>
  );
}

Seo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  noIndex: PropTypes.bool,
};

export default Seo;
